import {BaseResponseDTO} from "./response/base.response.dto";
import printJS from 'print-js';

function esAndroid(): boolean {
  return /Android/i.test(navigator.userAgent);
}

function recortarEspacioEnBlanco(canvas: HTMLCanvasElement): HTMLCanvasElement {
  const ctx = canvas.getContext('2d');
  const { width, height } = canvas;
  const { data } = ctx.getImageData(0, 0, width, height);

  const filaTieneContenido = (fila: number): boolean => {
    const inicio = fila * width * 4;
    for (let x = 0; x < width; x++) {
      const i = inicio + x * 4;
      if (data[i] < 250 || data[i + 1] < 250 || data[i + 2] < 250) return true;
    }
    return false;
  };

  let ultimaFilaConContenido = height - 1;
  while (ultimaFilaConContenido > 0 && !filaTieneContenido(ultimaFilaConContenido)) {
    ultimaFilaConContenido--;
  }

  const margen = 20;
  const alturaRecortada = Math.min(height, ultimaFilaConContenido + 1 + margen);
  if (alturaRecortada >= height) return canvas;

  const canvasRecortado = document.createElement('canvas');
  canvasRecortado.width = width;
  canvasRecortado.height = alturaRecortada;
  canvasRecortado.getContext('2d').drawImage(canvas, 0, 0);
  return canvasRecortado;
}

export class PdfDTO extends BaseResponseDTO {

  fileName: string;
  base64Content: string;
  enviadoAImpresora: boolean;
  nombreImpresora: string;

  generatePdfFromBase64() {
    if (esAndroid())
      this.mostrarVistaPreviaTablet();
    else
      printJS({printable: this.base64Content, type: 'pdf', base64: true, showModal: true, modalMessage: 'Procesando PDF'});
  }

  private async mostrarVistaPreviaTablet() {
    const binaryString = atob(this.base64Content);
    const byteArray = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      byteArray[i] = binaryString.charCodeAt(i);
    }

    const overlay = document.createElement('div');
    overlay.className = 'pdf-preview-overlay';

    const barra = document.createElement('div');
    barra.className = 'pdf-preview-barra';

    const btnImprimir = document.createElement('button');
    btnImprimir.className = 'btnBlack';
    btnImprimir.textContent = 'Imprimir';
    btnImprimir.onclick = () => {
      btnImprimir.disabled = true;
      window.print();
      setTimeout(() => { btnImprimir.disabled = false; }, 8000);
    };

    const btnCerrar = document.createElement('button');
    btnCerrar.className = 'btnGray';
    btnCerrar.textContent = 'Cerrar';
    btnCerrar.onclick = () => overlay.remove();

    barra.appendChild(btnImprimir);
    barra.appendChild(btnCerrar);

    const contenido = document.createElement('div');
    contenido.className = 'pdf-preview-contenido';

    overlay.appendChild(barra);
    overlay.appendChild(contenido);
    document.body.appendChild(overlay);

    const rutaPdfjs = new URL('assets/pdf.min.js', document.baseURI).href;
    try {
      const pdfjsLib: any = await import(/* @vite-ignore */ rutaPdfjs);
      pdfjsLib.GlobalWorkerOptions.workerSrc = new URL('assets/pdf.worker.min.js', document.baseURI).href;

      const pdf = await pdfjsLib.getDocument({ data: byteArray }).promise;
      for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);
        const viewport = page.getViewport({ scale: 2 });
        const canvas = document.createElement('canvas');
        canvas.width = viewport.width;
        canvas.height = viewport.height;
        await page.render({ canvasContext: canvas.getContext('2d'), viewport }).promise;

        const canvasRecortado = recortarEspacioEnBlanco(canvas);
        const imagen = document.createElement('img');
        imagen.src = canvasRecortado.toDataURL('image/png');
        contenido.appendChild(imagen);
      }
    } catch (error) {
      const mensajeError = document.createElement('pre');
      mensajeError.className = 'pdf-preview-error';
      mensajeError.textContent = `No se pudo generar la vista previa.\nRuta: ${rutaPdfjs}\nError: ${(error as any)?.message || error}`;
      contenido.appendChild(mensajeError);
    }
  }

}
